<template>
  <v-container fluid pa-0>
    <!-- Filtros -->
    <v-layout row wrap>
      <v-flex xs12>
        <v-card v-if="filtros" class="mb-4">
          <v-toolbar dense color="grey lighten-2">
            <v-toolbar-title class="title">Filtros</v-toolbar-title>
            <v-divider
              class="mx-2"
              inset
              vertical
            ></v-divider>
            <v-spacer></v-spacer>
            <v-tooltip bottom>
              <v-btn flat icon @click="filtros = false" slot="activator">
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cancelar</span>
            </v-tooltip>
            
            <v-tooltip bottom>
              <v-btn fab dark small color="primary" icon @click="aplicaFiltros" slot="activator">
                <v-icon>done</v-icon>
              </v-btn>
              <span>Aplicar</span>
            </v-tooltip>
          </v-toolbar>
          <v-container fluid grid-list-xl>
            <v-layout row wrap>
              <v-flex xs12 md4>
                <span class="subheading font-weight-medium">Status</span>
                <v-checkbox color="primary" v-model="args.status" label="Ativo" value="A" height="0" class="mb-0"></v-checkbox>
                <v-checkbox color="primary" v-model="args.status" label="Excluido" value="C" height="0" class="my-0"></v-checkbox>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
      <div :class="filtros ? '' : 'pos-abs-fixed'">
        <v-toolbar dense color="grey lighten-2">
          <v-toolbar-title class="title">Layouts Sql</v-toolbar-title>
          <v-divider
            class="mx-2"
            inset
            vertical
          ></v-divider>
          <v-spacer></v-spacer>
          <v-text-field prepend-inner-icon="search" clearable v-model="searchTerm"></v-text-field>
          <v-tooltip bottom>
            <v-btn
              color="primary" 
              fab 
              dark 
              small
              @click="abreModalCadastroLayoutSql"
              slot="activator"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <span>Adicionar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat icon small slot="activator" @click="aplicaFiltros">
              <v-icon>refresh</v-icon>
            </v-btn>
            <span>Atualizar</span>
          </v-tooltip>
          <v-tooltip bottom>
            <span>Opções</span>
            <v-menu bottom left slot="activator">
              <v-btn flat icon small slot="activator">
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  @click="editItemSelected"
                >
                  <v-list-tile-title>
                    <v-icon small class="pr-1">edit</v-icon>
                      Alterar
                    </v-list-tile-title>
                </v-list-tile>
                <v-list-tile
                  @click="deleteItemSelected"
                >
                  <v-list-tile-title>
                    <v-icon small class="pr-1">delete</v-icon>
                    Excluir
                  </v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat icon small slot="activator" @click="filtros = !filtros">
              <v-icon>filter_list</v-icon>
            </v-btn>
            <span>Filtros</span>
          </v-tooltip>
        </v-toolbar>
      </div>
    <GridLayoutSql
      :items="layoutsSql" 
      :searchTerm="searchTerm" 
      :loading="loading"
      @editItemSelected="editItemSelected"
    />
    <ModalCadastroLayoutSql v-model="modalCadastroLayoutSql" @layoutSalvo="layoutSalvo" />
    <ModalEditCadastroLayoutSql 
      v-model="modalLayoutSql"
      :editLayoutSql="layoutSqlSelected"
      @layoutEditSalvo="layoutSalvoOuFechado"
      @input="layoutSalvoOuFechado"
    />
  </v-container>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import GridLayoutSql from '@/components/layoutSql/GridLayoutSql'
import ModalCadastroLayoutSql from '@/components/layoutSql/ModalCadastroLayoutSql'
import ModalEditCadastroLayoutSql from '@/components/layoutSql/ModalEditCadastroLayoutSql'
import { changePageTitle } from '../utils/changePageTitle';

export default {
  name: 'LayoutsSqlView',
  components: {
    GridLayoutSql,
    ModalCadastroLayoutSql,
    ModalEditCadastroLayoutSql,
  },
  data: () => ({
    filtros: false,
    modalCadastroLayoutSql: false,
    modalLayoutSql: false,
    searchTerm: '',
    loading: false,
    args: {
      status: 'A'
    },
    layoutSqlSelected: null
  }),
  computed: {
    ...mapGetters(['isAdmin', 'layoutsSql', 'layoutsSqlSelected', 'sqls']),
    msgDelete() {
      return this.layoutsSqlSelected.length > 1 ? 
        `Tem certeza que deseja excluir: ${this.layoutsSqlSelected.length} registros?` :
        `Tem certeza que deseja excluir: ${this.layoutsSqlSelected[0].Descricao}?`;
    }
  },
  methods: {
    ...mapActions([
      'fetchLayoutsSql', 
      'deleteLayoutSql', 
      'fetchSqls', 
      'fetchRecursosSistema', 
      'fetchSituacoesAtividade', 
      'fetchSituacoesProjeto', 
      'fetchTiposProjeto', 
      'fetchTiposAtividade', 
      'fetchTiposOcorrencia',
      'fetchTiposSituacao',
      'fetchTags',
      'fetchWorkflows',
      'fetchColaboradores',
      'resetaLayoutSqlUsuarios'
    ]),
    ...mapMutations(['showNotification', 'closeNotification']),
    layoutSalvo(payload) {
      this.editItemSelected(payload);
    },
    layoutSalvoOuFechado() {
      this.layoutSqlSelected = null;
    },
    abreModalCadastroLayoutSql() {
      this.modalCadastroLayoutSql = true;
    },
    abreModalLayoutSql() {
      this.modalLayoutSql = true;
      this.resetaLayoutSqlUsuarios();
      this.layoutSqlSelected = null;
    },
    editItemSelected(payload) {
      if (payload && payload.IdLayoutSql) {
        this.layoutSqlSelected = payload;
        this.modalLayoutSql = true;
      } else if (this.layoutsSqlSelected.length) {
        this.layoutSqlSelected = this.layoutsSqlSelected[this.layoutsSqlSelected.length - 1];
        this.modalLayoutSql = true;
      } else {
        this.showNotification({ text: "Selecione um layout sql para alterar.", status: 'error' });
      }
    },
    async deleteItemSelected() {
      if (this.layoutsSqlSelected.length) {
        if (confirm(this.msgDelete)) {
          let promises = [];
          this.layoutsSqlSelected.forEach(layoutSql => promises.push(this.deleteLayoutSql(layoutSql.IdLayoutSql)));

          await Promise.all(promises)
            .then(() => this.showNotification({ text: 'Operação concluída com sucesso!', status: 'success' }))
            .catch(error => this.showNotification({ text: `Ocorreu um erro ao tentar excluir o(s) layout(s) sql: ${error}`, status: 'error' }));
        }
      } else {
        this.showNotification({ text: "Selecione pelo menos um layout sql para excluir.", status: 'error' });
      }
    },
    async aplicaFiltros() {
      this.loading = true;
      try {
        await this.fetchLayoutsSql(this.args);
        this.loading = false;
        this.showNotification({ text: "Lista atualizada.", status: 'success' });
      } catch (error) {
        this.loading = false;
        this.showNotification({ text: `Ocorreu um erro ao buscar os layouts sql: ${error}`, status: 'error' });
      }

      this.salvaConfigPesquisa();
      this.filtros = false;
    },
    // Salva no localStorage o termo pesquisado caso houver, a config de paginação da tela de pesquisa e o status
    salvaConfigPesquisa() {
      this.searchTerm ? localStorage.setItem('LayoutsSqlViewSearchTerm', this.searchTerm) : localStorage.setItem('LayoutsSqlViewSearchTerm', '');
      localStorage.setItem('statusLayoutSql', this.args.status);
    },
    // Recupera do localStorage o termo pesquisado caso houver, a config de paginação da tela de pesquisa e o status
    recuperaConfigPesquisa() {
      // Verifica se existe no localStorage o item statusLayoutSql salvo anteriormente
      if (localStorage.getItem('statusLayoutSql')) {
        this.args.status = localStorage.getItem('statusLayoutSql');
      }
      // Verifica se existe o termo pesquisado salvo anteriormente
      if (localStorage.getItem('LayoutsSqlViewSearchTerm')) {
        this.searchTerm = localStorage.getItem('LayoutsSqlViewSearchTerm');
      } else {
        this.searchTerm = '';
      }
    }
  },
  async created() {
    changePageTitle('Layouts Sql');
    if (!this.isAdmin) {
      return this.$router.go(-1);
    }
    this.recuperaConfigPesquisa();
    await this.aplicaFiltros();
    await this.fetchSqls({ status: 'A' });
    await this.fetchRecursosSistema({ status: 'A' });
    await this.fetchSituacoesAtividade();
    await this.fetchSituacoesProjeto();
    await this.fetchTiposAtividade();
    await this.fetchTiposProjeto();
    await this.fetchTiposOcorrencia();
    await this.fetchTiposSituacao();
    await this.fetchColaboradores();
    await this.fetchTags();
    await this.fetchWorkflows();
  }
}
</script>

<style scoped>
.pos-abs-fixed {
  z-index: 5;
  position: relative;
  padding-bottom: 50px;
}
.pos-abs-fixed > :first-child {
  position: fixed;
}
</style>